import { uuidv4 } from "../../../utility";

export function createChatResponse({ sent, message, response }) {
  return {
    sent: sent,
    message: message,
    response: response
  };
}



export const createMessage = (message = createChatResponse()) => {
  return [
    {
      id: uuidv4(),
      type: "user",
      text: message.message,
      sent: message.sent,
      loading: false,
      cancelled: false,
    },
    {
      id: uuidv4(),
      type: "chatbot",
      text: message.response,
      sent: message.sent,
      loading: false,
      cancelled: false,
    },
  ]
}

export const createMessages = (messages = []) => {
  return messages.map(message => createMessage(message)).flat();
}